<template>
  <b-card-code title="" no-body>
    <b-card-body>
      <b-row>
        <b-col md="2" xl="2" class="mb-1">
          <!-- basic -->
          <b-form-group label="Cari" label-for="basicInput">
            <b-form-input
              id="basicInput"
              placeholder="Search"
              v-model="search"
            />
          </b-form-group>
        </b-col>
        
        

        <b-col md="2" xl="2" class="mb-1">
          <!-- basic -->
          <b-form-group label="id" label-for="id">
            <b-form-input
              id="id"
              placeholder="100"
              v-model="id"
            />
          </b-form-group>
        </b-col>
       
        
        <b-col lg="3" md="3" class="mb-1">
          <b-button
            v-ripple.400="'rgba(234, 84, 85, 0.15)'"
            variant="outline-primary"
            class="mt-0 mt-md-2"
            @click="refreshPage()"
          >
            <feather-icon icon="SearchIcon" class="mr-25" />
            <span>Search</span>
          </b-button>
        </b-col>
        <b-col lg="2" md="2" class="mb-1">
          <b-button
            v-ripple.400="'rgba(234, 84, 85, 0.15)'"
            variant="primary"
            class="mt-0 mt-md-2"
            @click="createPlatform()"
          >
            <feather-icon icon="EditIcon" class="mr-25" />
            <span>Input New</span>
          </b-button>
        </b-col>
      </b-row>

      
    </b-card-body>

    <!-- table -->
    <b-table
      ref="selectableTable"
      selectable
      :items="items"
      :fields="fields"
      responsive
      class="mb-0"
      @row-selected="onRowSelected"
    >
      
    <template #cell(action)="data">
        <b-dropdown variant="link" no-caret toggle-class="p-0" right>
          <template #button-content>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="btn-icon"
            >
              <feather-icon icon="SettingsIcon" />
            </b-button>
          </template>

          <b-dropdown-item @click="updatePlatform(data.item)">
            <feather-icon icon="EditIcon" size="16" />
            <span class="align-middle ml-50">Update</span>
          </b-dropdown-item>
         
          <b-dropdown-item @click="deletePlatform(data.item)">
            <feather-icon icon="TrashIcon" size="16" />
            <span class="align-middle ml-50">Delete</span>
          </b-dropdown-item>
        
        
        </b-dropdown>
      </template>
     
    </b-table>

    <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
      <div></div>
      <!--pagination -->
      <div class="demo-inline-spacing pt-0">
        <b-pagination
          v-model="currentPage"
          hide-goto-end-buttons
          :total-rows="rows"
          :per-page="perPage"
        />
      </div>
    </b-card-body>
    

    <b-modal id="modal-create-platform" hide-footer>
      <template #modal-title> Update Platform </template>
      <div class="d-block text-center">
        <!-- <p>Apakah anda yakin? Jika ya silahkan input deskripsi.</p> -->
      </div>
     
          <!-- basic -->
          
          <b-col md="12" xl="12" class="mb-1">
            <!-- basic -->
            <b-form-group label="Name" label-for="basicInput">
              <b-form-input
                id="basicInput"
                placeholder="Name"
                v-model="name"
              />
            </b-form-group>
          </b-col>

          <b-col md="12" xl="12" class="mb-1">
            <!-- basic -->
            <b-form-group label="Value" label-for="thevalue">
              <b-form-input
                id="thevalue"
                placeholder="value"
                v-model="value"
              />
            </b-form-group>
          </b-col>


      <b-button
        class="mt-3"
        variant="outline-primary"
        block
        @click="submitCreate()"
      >
        <feather-icon icon="SendIcon" /> Submit
      </b-button>
    </b-modal>
    <b-modal id="modal-update-platform" hide-footer>
      <template #modal-title> Update Platform </template>
      <div class="d-block text-center">
        <!-- <p>Apakah anda yakin? Jika ya silahkan input deskripsi.</p> -->
      </div>
     
          <!-- basic -->
          
          <b-col md="12" xl="12" class="mb-1">
            <!-- basic -->
            <b-form-group label="Name" label-for="basicInput">
              <b-form-input
                id="basicInput"
                placeholder="Name"
                v-model="name"
              />
            </b-form-group>
          </b-col>

          <b-col md="12" xl="12" class="mb-1">
            <!-- basic -->
            <b-form-group label="Value" label-for="thevalue">
              <b-form-input
                id="thevalue"
                placeholder="value"
                v-model="value"
              />
            </b-form-group>
          </b-col>


      <b-button
        class="mt-3"
        variant="outline-primary"
        block
        @click="submitUpdate()"
      >
        <feather-icon icon="SendIcon" /> Submit
      </b-button>
    </b-modal>
    <b-modal id="modal-delete-platform" hide-footer>
      <template #modal-title> Update Platform </template>
      <div class="d-block text-center">
        <p>Apakah anda yakin?</p>
      </div>
     
          <!-- basic -->
          
          


      <b-button
        class="mt-3"
        variant="outline-primary"
        block
        @click="submitDelete()"
      >
        <feather-icon icon="SendIcon" /> Submit
      </b-button>
    </b-modal>
  </b-card-code>
  
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BTable, BButton, BFormGroup, BAvatar, BBadge, BCardBody, BPagination, BFormTextarea,
  BButtonToolbar, BButtonGroup, BDropdown, BDropdownItem, BFormInput, BRow, BCol, BModal
} from 'bootstrap-vue'
import API from '@/api'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import router from '@/router'

export default {
  components: {
    BCardCode,
    BTable,
    BButton,
    BAvatar,
    BCardBody,
    BBadge,
    vSelect,
    BPagination,
    BButtonToolbar,
    BButtonGroup,
    BButton,
    BDropdown,
    BDropdownItem,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BModal,
    BFormTextarea
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      currentPage: 1,
      rows: 0,
      perPage: 20,
      modes: ['multi', 'single', 'range'],
      fields: ['id','name', 'value', 'created_at', 'action'],
      /* eslint-disable global-require */
      items: [],
      /* eslint-disable global-require */
      search: null,
      id: null,
      detailPlatform: null,
      name: null,
      value: null
      

    }
  },
  methods: {
    onRowSelected(items) {
      this.selected = items
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows()
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected()
    },
    refreshPage() {
      if (this.currentPage == 1) {
        this.getPlatform()
      }
      else {
        this.currentPage = 1
      }

    },
    async getPlatform() {

      try {
        this.$store.commit('SET_IS_LOADING_FOR_SUBMIT', true)

        const form = {
          limit: this.perPage,
          page: this.currentPage,
          name: this.search,
          id: this.id,
          is_pagination:true
        }
        const data   = await this.encryptRequest(API.platform.platform(form))
        this.data_table = data.data.data
        this.items = data.data.data
        this.rows = data.data.total

        this.handleMsgSuccess('Berhasil tampilkan data log')
      } catch (error) {
        console.log(error)
        this.handleMsgErrors(error, 'Terjadi kesalahan silahkan coba lagi!')
      } finally {
        this.$store.commit('SET_IS_LOADING_FOR_SUBMIT', false)
      }
    },
    createPlatform() {
      this.$bvModal.show("modal-create-platform")
    },
    updatePlatform(item) {
      this.detailPlatform = item
      this.name = item.name
      this.value = item.value
      console.log(this.detailPlatform)
      this.$bvModal.show("modal-update-platform")

    },
    deletePlatform(item) {
      this.detailPlatform = item
      console.log(this.detailPlatform)
      this.$bvModal.show("modal-delete-platform")

    },
    async submitUpdate() {

      try {
        this.$store.commit('SET_IS_LOADING_FOR_SUBMIT', true)
        const form = {
          name: this.name,
          value:this.value,
          id:this.detailPlatform.id
        }
        const data   = await this.encryptRequest(API.platform.update_platform(form))

        this.handleMsgSuccess('Berhasil update platform')
        this.$bvModal.hide("modal-update-platform")
        this.getPlatform()
      } catch (error) {
        console.log(error)
      } finally {
        this.$store.commit('SET_IS_LOADING_FOR_SUBMIT', false)
      }
    },
    async submitDelete() {

      try {
        this.$store.commit('SET_IS_LOADING_FOR_SUBMIT', true)
        const form = {
          id:this.detailPlatform.id
        }
        const data   = await this.encryptRequest(API.platform.delete_platform(form))

        this.handleMsgSuccess('Berhasil delete platform')
        this.$bvModal.hide("modal-delete-platform")
        this.getPlatform()
      } catch (error) {
        console.log(error)
      } finally {
        this.$store.commit('SET_IS_LOADING_FOR_SUBMIT', false)
      }
    },
    async submitCreate() {
      this.$store.commit('SET_IS_LOADING_FOR_SUBMIT', true)
      try {
        
        var input = { 
            name: this.name, 
            value: this.value,
          }
        const {}  = await this.encryptRequest(API.platform.create_platform(input))
        this.handleMsgSuccess('Berhasil Create Platform')
        this.getPlatform()
        this.$bvModal.hide("modal-create-platform")
      } catch (error) {
        console.log(error)
        this.handleMsgErrors(error, 'Terjadi kesalahan silahkan coba lagi!')
      }
      finally {
        this.$store.commit('SET_IS_LOADING_FOR_SUBMIT', false)
      }


    },



  },
  mounted() {
    this.getPlatform()
    
  },
  watch: {
    currentPage() {
      this.getPlatform()
    },

  }
}
</script>

<style lang="scss">
.b-table-selectable {
  .feather {
    font-size: 1.3rem;
  }
}
</style>
